module.exports = __webpack_public_path__ + "static/media/concept.c721141f.jpg";